import Notifications from 'components/Notifications';
import { connect } from 'react-redux';
import { closeNotification } from "actions/notifications";

export default connect(
  st => ({
    items: st.notifications
  }),
  { onItemClose: closeNotification}
)(Notifications);